module.exports = __webpack_public_path__ + "static/media/Logo_white.3a12db9c.png";